import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import TextInput from "../../common/TextInput";

const IdentificatieCodeEditForm = (props) => {
	const {
		onCancel,
		onContinue,
		errors,
		organisatie,
		onChangeIdentificatieCode
	} = props;

	const linkClass = { "color": "#39b4e8", "font-weight": "bold", "paddingBottom": '2px', "paddingTop": '2px' };

	return (
		<Form
			headerVisible={false}
			isNotRequired
			rightButtonLabel="Ga verder"
			onRightButtonClick={onContinue}
			leftButtonLabel="Annuleer"
			onLeftButtonClick={onCancel}>
			<Fieldset title="Identificatiecode toevoegen/wijzigen">
				<Row>
					<TextInput
						name="naam"
						value={organisatie.naam}
						label="Naam (Afkorting)"
						size={6}
						disabled />
						<TextInput
						name="sporttak"
						value={organisatie.sporttakken}
						label="Sporttak"
						size={6}
						disabled/>
				</Row>
				<Row>
					<TextInput
						name="identificatieCode"
						value={organisatie.identificatieCode}
						label="identificatieCode"
						onChange={onChangeIdentificatieCode}
						size={6}
						hasFocus={true} />
				</Row>
			</Fieldset>
		</Form>
	);
};

IdentificatieCodeEditForm.propTypes = {
	onCancel: PropTypes.func,
	onContinue: PropTypes.func,
	onChangeIdentificatieCode: PropTypes.func,
	errors: PropTypes.array,
	organisatie: PropTypes.object,
	sporttakNaam: PropTypes.string
};

export default IdentificatieCodeEditForm;
